(ns app.front.view.fee.summary
  (:require [app.domain.fee.model :as fee-model]
            [app.domain.group.config.model :as config-model]
            [app.domain.util :as du]
            [app.domain.workspace.model :as workspace-model]
            [app.front.ui.section :as section]
            [app.front.ui.table :as ui-table]
            [app.front.util :as futil]
            [app.front.view.workspace.util :as ws-util]
            [core.front.event :refer [<sub]]
            [core.util.util :as util]
            [potpuri.core :as p]))


(defn group-bills [bills]
  (->> bills
       (filter (du/in-state-fn :bill.state/unpaid))
       (group-by :bill/phase)
       ;; group by workspace
       (p/map-vals (partial group-by (comp :entity/parent :entity/parent)))
       (p/map-vals (partial p/map-vals (comp (partial apply +)
                                             (partial map fee-model/bill-amount))))))

(defn total [[workspace amount]]
  (futil/money-string amount
                      (-> workspace
                          :domain/authority-group
                          :group/currency)))

(defn target-and-category
  "Takes workspace entities and renders a description text"
  [lang workspace]
  (futil/str-and-desc
    (some-> workspace
            workspace-model/workspace-application
            :application/work-target-group-config
            (config-model/localized-name lang))
    (-> workspace
        :workspace/category-group-config
        (config-model/localized-name lang))))

(defn total-subtitle [tr ws-totals]
  (let [currencies (->> ws-totals
                        keys
                        (map :domain/authority-group)
                        (map :group/currency)
                        distinct)]
    (when-let [currency (util/only currencies)]
      ;; sanity check - don't allow multiple currencies -
      ;; in practice a single municipality would be expected
      ;; to use only one currency, even in Weimar Republic
      (let [total (->> ws-totals vals (apply +))]
        (str (tr [:fees/total-due]) ": "
             (futil/money-string total currency))))))

(defn get-phase [ws-totals phase]
  (if (= phase :bill.phase/permit)
    (let [permit-types (->> ws-totals
                            keys
                            (map :workspace/permit-type)
                            set)]
      (cond
        (= #{:permit-type/P} permit-types)
        :bill.phase/permit-planning

        (contains? permit-types :permit-type/P)
        :bill.phase/permit-planning-or-other

        :else
        :bill.phase/permit))
    phase))

(defn phase-bills-subsection [{:keys [tr lang ws-totals phase show-address?]}]
  [section/subsection-base
   [section/subsection-content
    {:title    (tr [(get-phase ws-totals phase)])
     :subtitle (total-subtitle tr ws-totals)}
    [ui-table/modern-responsive-table
     {:cols    [(when show-address?
                  [:workspace/address
                   (comp :workspace/address first)])
                [:workspace/category
                 (comp (partial target-and-category lang)
                       first)
                 (when show-address? {:width "400px"})]
                [:workspace/municipal-case-id
                 (comp (some-fn :workspace/municipal-case-id
                                :workspace/id)
                       first)
                 {:width "250px"}]
                [:fees/total-due
                 total
                 {:width "100px"}]]
      :id-func (comp :db/id first)
      :tr      tr
      :link    {:description (comp ws-util/workspace-link-description first)
                :make-href   (comp ws-util/workspace-or-resume-application-href first)}
      :items   ws-totals}]]])

(defn bills-list [{:keys [bills-sub tr show-address?]}]
  [:<>
   (let [bills (<sub bills-sub)
         lang  (<sub [:language])]
     (if (empty? bills)
       (tr [:project/no-unpaid-bills])
       (for [[phase ws-totals] bills]
         ^{:key phase}
         [phase-bills-subsection (util/mmap phase ws-totals tr lang show-address?)])))])
